"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockManyDifferentLeitungJsons = void 0;
const ArticleSpecs_1 = require("../ArticleSpecs");
const LeitungCategory_1 = require("./LeitungCategory");
const LeitungModel_1 = require("./LeitungModel");
exports.mockManyDifferentLeitungJsons = [
    {
        EntityId: '1606229687692_204928',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        IsPlaceholder: true,
        ArtNrExists: false,
        BeschriftungText: '',
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        LaengeUeberstandLock: LeitungModel_1.LeitungslaengeUeberstandLock.laengeAndFestpunkt,
        IAIndex: 'F1',
        CFX: '',
        LeitungIndex: '',
        Bezeichnung: { 'de-DE': '102' },
        GewichtKgProKm: { Unit: 'kg_km', Value: 100 },
        Aussendurchmesser: { Unit: 'mm', Value: 7 },
        BiegeradiusMin: { Unit: 'mm', Value: 100 },
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606229687693_204929',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        IsPlaceholder: true,
        ArtNrExists: false,
        BeschriftungText: '',
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        LaengeUeberstandLock: LeitungModel_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer,
        IAIndex: 'F2',
        CFX: '',
        LeitungIndex: '',
        Bezeichnung: { 'de-DE': '102' },
        GewichtKgProKm: { Unit: 'kg_km', Value: 100 },
        Aussendurchmesser: { Unit: 'mm', Value: 7 },
        BiegeradiusMin: { Unit: 'mm', Value: 100 },
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606229687693_204930',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        IsPlaceholder: true,
        ArtNrExists: false,
        BeschriftungText: '',
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        LaengeUeberstandLock: LeitungModel_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer,
        IAIndex: 'F3',
        CFX: '',
        LeitungIndex: '',
        Bezeichnung: { 'de-DE': '182' },
        GewichtKgProKm: { Unit: 'kg_km', Value: 100 },
        Aussendurchmesser: { Unit: 'mm', Value: 7 },
        BiegeradiusMin: { Unit: 'mm', Value: 100 },
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606229687693_204931',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        IsPlaceholder: true,
        ArtNrExists: false,
        BeschriftungText: '',
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        LaengeUeberstandLock: LeitungModel_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer,
        IAIndex: 'F4',
        CFX: '',
        LeitungIndex: '',
        Bezeichnung: { 'de-DE': '212' },
        GewichtKgProKm: { Unit: 'kg_km', Value: 100 },
        Aussendurchmesser: { Unit: 'mm', Value: 7 },
        BiegeradiusMin: { Unit: 'mm', Value: 100 },
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606229687693_204932',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        IsPlaceholder: true,
        ArtNrExists: false,
        BeschriftungText: '',
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        LaengeUeberstandLock: LeitungModel_1.LeitungslaengeUeberstandLock.festpunktAndMitnehmer,
        IAIndex: 'F5',
        CFX: '',
        LeitungIndex: '',
        Bezeichnung: { 'de-DE': '213' },
        GewichtKgProKm: { Unit: 'kg_km', Value: 100 },
        Aussendurchmesser: { Unit: 'mm', Value: 9 },
        BiegeradiusMin: { Unit: 'mm', Value: 100 },
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465515236_7562',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '1',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465515239_7564',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '2',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465515241_7566',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '3',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465515242_7568',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '4',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465515244_7570',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '5',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465519142_7658',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '6',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465519143_7660',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '7',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465529170_7764',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label1',
        IAIndex: '8',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465529172_7766',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label1',
        IAIndex: '9',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465529174_7768',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label1',
        IAIndex: '10',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465532438_7896',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '11',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465532440_7898',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '12',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465532442_7900',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '13',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465532443_7902',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '14',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465532444_7904',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '15',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465538201_8072',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '7G0,50',
            'en-US': '7G0.50',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 7.5 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 56.25 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.05.07.UL', US: 'CF130-05-07-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 7G0,5 | +5 °C bis +70 °C | Biegeradius: 56 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 7,5 mm | 7G0,5 | Radio en cadena: 56 mm (Torsión: ±90º/m)',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 76 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 37 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32905,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.05.07.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '16',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465545477_8249',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '12G1,5',
            'en-US': '12G1.5',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 13 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 97.5 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.15.12.UL', US: 'CF130-15-12-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 12G1,5 | +5 °C bis +70 °C | Biegeradius: 98 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 13 mm | 12G1,5 | Radio en cadena: 98 mm (Torsión: ±90º/m)',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 288 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 179 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32928,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.15.12.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '17',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465545479_8251',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '12G1,5',
            'en-US': '12G1.5',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 13 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 97.5 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.15.12.UL', US: 'CF130-15-12-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 12G1,5 | +5 °C bis +70 °C | Biegeradius: 98 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 13 mm | 12G1,5 | Radio en cadena: 98 mm (Torsión: ±90º/m)',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 288 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 179 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32928,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.15.12.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '18',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465545481_8253',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 20 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 50 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 50 },
        Leitungsaufbau: {
            'de-DE': '12G1,5',
            'en-US': '12G1.5',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 13 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 50 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 2 },
        RAL_Nummer: '6005',
        AuhiTemperaturMax: { Unit: '°C', Value: 70 },
        BiegeradiusMin: { Unit: 'mm', Value: 97.5 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 3 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF130.15.12.UL', US: 'CF130-15-12-UL' },
        Bezeichnung: {
            'de-DE': 'chainflex®Steuerleitung PVC | 12G1,5 | +5 °C bis +70 °C | Biegeradius: 98 mm',
            'en-GB': 'chainflex® control cable CF130.UL PVC',
            'it-IT': 'chainflex® cavo di controllo CF130.UL in PVC',
            'pt-PT': 'Cabo de comando chainflex® CF130.UL em PVC',
            'es-ES': 'chainflex® cable de control | PVC | Ø 13 mm | 12G1,5 | Radio en cadena: 98 mm (Torsión: ±90º/m)',
            'ja-JP': 'チェーンフレックス 制御・動力ケーブル CF130.UL PVC外被',
            'zh-CN': 'chainflex® CF130.UL PVC 高柔性控制电缆',
            'sv-SE': 'chainflex® styrkabel CF130.UL PVC',
            'hu-HU': 'chainflex® vezérlőkábel CF130.UL PVC',
            'da-DK': 'chainflex® styrekabel CF130.UL PVC',
            'ko-KR': 'chainflex® CF130.UL 제어 케이블 PVC',
            'cs-CZ': 'Ovládací kabel chainflex® CF130.UL z PVC',
            'en-US': 'chainflex® CF130-UL control cable PVC',
            'nl-NL': 'chainflex® stuurstroomkabel CF130.UL PVC',
            'pl-PL': 'Przewód sterowania chainflex® CF130.UL PVC',
            'fr-FR': 'Câble de commandes chainflex® CF130.UL PVC',
            'zh-TW': 'chainflex® CF130.UL高柔性控制電纜PVC',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 288 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 20 },
        Kupferzahl: { Unit: 'kg_km', Value: 179 },
        AuhiTemperaturMin: { Unit: '°C', Value: 5 },
        Id: 32928,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 20 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF130.15.12.UL',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: 'label2',
        IAIndex: '19',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465562656_8455',
        Categories: [LeitungCategory_1.LeitungCategory.ServoCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ServoCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G2,5+(2x1,5)C)C',
            'en-US': '(4G2.5+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 14 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 140 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF270.UL.25.15.02.01.D', US: 'CF270-UL-25-15-02-01-D' },
        Bezeichnung: {
            'de-DE': 'chainflex®Servoleitung PUR | (4G2,5+(2x1,5)C)C | -25 °C bis +80 °C | Biegeradius: 140 mm',
            'en-GB': 'chainflex® CF270UL.D PUR servo cable, 1 control pair shielded',
            'es-ES': 'chainflex® cable de servo | PUR | Ø 14 mm | (4G2,5+(2x1,5)C)C | Radio en cadena: 140 mm (Torsión: ±30º/m)',
            'ja-JP': 'チェーンフレックス CF270UL.D PUR外被 複合ケーブル、制御ペアｘ1、シールド付',
            'zh-CN': 'chainflex® CF270UL.D PUR高柔性伺服电缆，1条带屏蔽的控制对线',
            'fr-FR': 'Servoconducteur chainflex® CF270UL.D PUR, 1 paire de contrôle blindée',
            'it-IT': 'Cavi servo chainflex® CF270UL.D in PUR, 1 coppia di segnale schemata',
            'pt-PT': 'Cabo de servomotor chainflex® CF270UL.D em PUR, 1 par de comando com malha',
            'pl-PL': 'Przewód serwo chainflex® CF270UL.D PUR, 1 para sterowania z ekranowaniem',
            'cs-CZ': 'Servo kabel chainflex® CF270UL.D PUR, 1 stíněný ovládací pár',
            'da-DK': 'chainflex® CF270UL.D PUR-servokabel, 1 styrepar med skærm',
            'hu-HU': 'chainflex® CF270UL.D PUR szervókábel, 1 árnyékolt vezérlőpár',
            'sv-SE': 'chainflex® CF270UL.D PUR-servokabel, 1 skärmat styrpar',
            'en-US': 'chainflex® CF270UL-D PUR servo cable, 1 control pair shielded',
            'nl-NL': 'chainflex® CF270UL.D PUR servokabel 1 besturingspaar afgeschermd PUR',
            'ko-KR': 'chainflex® CF270UL.D PUR 서보 케이블, 1개의 차폐된 제어 쌍',
            'zh-TW': 'chainflex® CF270UL.D PUR高柔性伺服電纜,1條帶遮罩的控制對線',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 301 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 210 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 46589,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF270.UL.25.15.02.01.D',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '20',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465562658_8457',
        Categories: [LeitungCategory_1.LeitungCategory.ServoCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ServoCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G2,5+(2x1,5)C)C',
            'en-US': '(4G2.5+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 14 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 140 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF270.UL.25.15.02.01.D', US: 'CF270-UL-25-15-02-01-D' },
        Bezeichnung: {
            'de-DE': 'chainflex®Servoleitung PUR | (4G2,5+(2x1,5)C)C | -25 °C bis +80 °C | Biegeradius: 140 mm',
            'en-GB': 'chainflex® CF270UL.D PUR servo cable, 1 control pair shielded',
            'es-ES': 'chainflex® cable de servo | PUR | Ø 14 mm | (4G2,5+(2x1,5)C)C | Radio en cadena: 140 mm (Torsión: ±30º/m)',
            'ja-JP': 'チェーンフレックス CF270UL.D PUR外被 複合ケーブル、制御ペアｘ1、シールド付',
            'zh-CN': 'chainflex® CF270UL.D PUR高柔性伺服电缆，1条带屏蔽的控制对线',
            'fr-FR': 'Servoconducteur chainflex® CF270UL.D PUR, 1 paire de contrôle blindée',
            'it-IT': 'Cavi servo chainflex® CF270UL.D in PUR, 1 coppia di segnale schemata',
            'pt-PT': 'Cabo de servomotor chainflex® CF270UL.D em PUR, 1 par de comando com malha',
            'pl-PL': 'Przewód serwo chainflex® CF270UL.D PUR, 1 para sterowania z ekranowaniem',
            'cs-CZ': 'Servo kabel chainflex® CF270UL.D PUR, 1 stíněný ovládací pár',
            'da-DK': 'chainflex® CF270UL.D PUR-servokabel, 1 styrepar med skærm',
            'hu-HU': 'chainflex® CF270UL.D PUR szervókábel, 1 árnyékolt vezérlőpár',
            'sv-SE': 'chainflex® CF270UL.D PUR-servokabel, 1 skärmat styrpar',
            'en-US': 'chainflex® CF270UL-D PUR servo cable, 1 control pair shielded',
            'nl-NL': 'chainflex® CF270UL.D PUR servokabel 1 besturingspaar afgeschermd PUR',
            'ko-KR': 'chainflex® CF270UL.D PUR 서보 케이블, 1개의 차폐된 제어 쌍',
            'zh-TW': 'chainflex® CF270UL.D PUR高柔性伺服電纜,1條帶遮罩的控制對線',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 301 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 210 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 46589,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF270.UL.25.15.02.01.D',
        UeberstandMitnehmer: { Unit: 'm', Value: 4 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '21',
        Leitungslaenge: { Unit: 'mm', Value: 7507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465566173_8673',
        Categories: [LeitungCategory_1.LeitungCategory.ServoCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ServoCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G2,5+(2x1,5)C)C',
            'en-US': '(4G2.5+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 14 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 140 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF270.UL.25.15.02.01.D', US: 'CF270-UL-25-15-02-01-D' },
        Bezeichnung: {
            'de-DE': 'chainflex®Servoleitung PUR | (4G2,5+(2x1,5)C)C | -25 °C bis +80 °C | Biegeradius: 140 mm',
            'en-GB': 'chainflex® CF270UL.D PUR servo cable, 1 control pair shielded',
            'es-ES': 'chainflex® cable de servo | PUR | Ø 14 mm | (4G2,5+(2x1,5)C)C | Radio en cadena: 140 mm (Torsión: ±30º/m)',
            'ja-JP': 'チェーンフレックス CF270UL.D PUR外被 複合ケーブル、制御ペアｘ1、シールド付',
            'zh-CN': 'chainflex® CF270UL.D PUR高柔性伺服电缆，1条带屏蔽的控制对线',
            'fr-FR': 'Servoconducteur chainflex® CF270UL.D PUR, 1 paire de contrôle blindée',
            'it-IT': 'Cavi servo chainflex® CF270UL.D in PUR, 1 coppia di segnale schemata',
            'pt-PT': 'Cabo de servomotor chainflex® CF270UL.D em PUR, 1 par de comando com malha',
            'pl-PL': 'Przewód serwo chainflex® CF270UL.D PUR, 1 para sterowania z ekranowaniem',
            'cs-CZ': 'Servo kabel chainflex® CF270UL.D PUR, 1 stíněný ovládací pár',
            'da-DK': 'chainflex® CF270UL.D PUR-servokabel, 1 styrepar med skærm',
            'hu-HU': 'chainflex® CF270UL.D PUR szervókábel, 1 árnyékolt vezérlőpár',
            'sv-SE': 'chainflex® CF270UL.D PUR-servokabel, 1 skärmat styrpar',
            'en-US': 'chainflex® CF270UL-D PUR servo cable, 1 control pair shielded',
            'nl-NL': 'chainflex® CF270UL.D PUR servokabel 1 besturingspaar afgeschermd PUR',
            'ko-KR': 'chainflex® CF270UL.D PUR 서보 케이블, 1개의 차폐된 제어 쌍',
            'zh-TW': 'chainflex® CF270UL.D PUR高柔性伺服電纜,1條帶遮罩的控制對線',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 301 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 210 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 46589,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF270.UL.25.15.02.01.D',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '22',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465566176_8675',
        Categories: [LeitungCategory_1.LeitungCategory.ServoCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ServoCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G2,5+(2x1,5)C)C',
            'en-US': '(4G2.5+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 14 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 140 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF270.UL.25.15.02.01.D', US: 'CF270-UL-25-15-02-01-D' },
        Bezeichnung: {
            'de-DE': 'chainflex®Servoleitung PUR | (4G2,5+(2x1,5)C)C | -25 °C bis +80 °C | Biegeradius: 140 mm',
            'en-GB': 'chainflex® CF270UL.D PUR servo cable, 1 control pair shielded',
            'es-ES': 'chainflex® cable de servo | PUR | Ø 14 mm | (4G2,5+(2x1,5)C)C | Radio en cadena: 140 mm (Torsión: ±30º/m)',
            'ja-JP': 'チェーンフレックス CF270UL.D PUR外被 複合ケーブル、制御ペアｘ1、シールド付',
            'zh-CN': 'chainflex® CF270UL.D PUR高柔性伺服电缆，1条带屏蔽的控制对线',
            'fr-FR': 'Servoconducteur chainflex® CF270UL.D PUR, 1 paire de contrôle blindée',
            'it-IT': 'Cavi servo chainflex® CF270UL.D in PUR, 1 coppia di segnale schemata',
            'pt-PT': 'Cabo de servomotor chainflex® CF270UL.D em PUR, 1 par de comando com malha',
            'pl-PL': 'Przewód serwo chainflex® CF270UL.D PUR, 1 para sterowania z ekranowaniem',
            'cs-CZ': 'Servo kabel chainflex® CF270UL.D PUR, 1 stíněný ovládací pár',
            'da-DK': 'chainflex® CF270UL.D PUR-servokabel, 1 styrepar med skærm',
            'hu-HU': 'chainflex® CF270UL.D PUR szervókábel, 1 árnyékolt vezérlőpár',
            'sv-SE': 'chainflex® CF270UL.D PUR-servokabel, 1 skärmat styrpar',
            'en-US': 'chainflex® CF270UL-D PUR servo cable, 1 control pair shielded',
            'nl-NL': 'chainflex® CF270UL.D PUR servokabel 1 besturingspaar afgeschermd PUR',
            'ko-KR': 'chainflex® CF270UL.D PUR 서보 케이블, 1개의 차폐된 제어 쌍',
            'zh-TW': 'chainflex® CF270UL.D PUR高柔性伺服電纜,1條帶遮罩的控制對線',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 301 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 210 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 46589,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF270.UL.25.15.02.01.D',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '23',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465566178_8677',
        Categories: [LeitungCategory_1.LeitungCategory.ServoCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ServoCables,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G2,5+(2x1,5)C)C',
            'en-US': '(4G2.5+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 14 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 140 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'CF270.UL.25.15.02.01.D', US: 'CF270-UL-25-15-02-01-D' },
        Bezeichnung: {
            'de-DE': 'chainflex®Servoleitung PUR | (4G2,5+(2x1,5)C)C | -25 °C bis +80 °C | Biegeradius: 140 mm',
            'en-GB': 'chainflex® CF270UL.D PUR servo cable, 1 control pair shielded',
            'es-ES': 'chainflex® cable de servo | PUR | Ø 14 mm | (4G2,5+(2x1,5)C)C | Radio en cadena: 140 mm (Torsión: ±30º/m)',
            'ja-JP': 'チェーンフレックス CF270UL.D PUR外被 複合ケーブル、制御ペアｘ1、シールド付',
            'zh-CN': 'chainflex® CF270UL.D PUR高柔性伺服电缆，1条带屏蔽的控制对线',
            'fr-FR': 'Servoconducteur chainflex® CF270UL.D PUR, 1 paire de contrôle blindée',
            'it-IT': 'Cavi servo chainflex® CF270UL.D in PUR, 1 coppia di segnale schemata',
            'pt-PT': 'Cabo de servomotor chainflex® CF270UL.D em PUR, 1 par de comando com malha',
            'pl-PL': 'Przewód serwo chainflex® CF270UL.D PUR, 1 para sterowania z ekranowaniem',
            'cs-CZ': 'Servo kabel chainflex® CF270UL.D PUR, 1 stíněný ovládací pár',
            'da-DK': 'chainflex® CF270UL.D PUR-servokabel, 1 styrepar med skærm',
            'hu-HU': 'chainflex® CF270UL.D PUR szervókábel, 1 árnyékolt vezérlőpár',
            'sv-SE': 'chainflex® CF270UL.D PUR-servokabel, 1 skärmat styrpar',
            'en-US': 'chainflex® CF270UL-D PUR servo cable, 1 control pair shielded',
            'nl-NL': 'chainflex® CF270UL.D PUR servokabel 1 besturingspaar afgeschermd PUR',
            'ko-KR': 'chainflex® CF270UL.D PUR 서보 케이블, 1개의 차폐된 제어 쌍',
            'zh-TW': 'chainflex® CF270UL.D PUR高柔性伺服電纜,1條帶遮罩的控制對線',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 301 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 210 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 46589,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'CF270.UL.25.15.02.01.D',
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '24',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    },
    {
        EntityId: '1606465574817_8918',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '25',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465574819_8920',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '26',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465579159_9176',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: '1',
        IAIndex: '27',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465581054_9440',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: '2',
        IAIndex: '28',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465581057_9442',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: '2',
        IAIndex: '29',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465585787_9722',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: '2',
        IAIndex: '30',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465585789_9724',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.folienlabel,
        BeschriftungText: '2',
        IAIndex: '31',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465588322_10020',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '32',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465591374_10324',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 50 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 100 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 100 },
        Leitungsaufbau: {
            'de-DE': '(3x(4x0,14)+(2x0,14+2x0,34)+2x1,5)C',
            'en-US': '(3x(4x0.14)+(2x0.14+2x0.34)+2x1.5)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 10 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 100 },
        FesteLaenge: false,
        AuhiGleitend: true,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 5 },
        RAL_Nummer: '6018',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 75 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 3 },
        ArtNr: { DE: 'MAT9841753', US: 'MAT9841753' },
        Bezeichnung: {
            'de-DE': 'readycable® Feedbackleitung passend zu Allen Bradley 2090-CFBM4DF-CDAFxx, Basisleitung PUR 7,5 x d',
            'en-GB': 'PUR feedback cable, Allen Bradley (Rockwell), base cable, 7.5 x d',
            'ja-JP': 'フィードバックケーブル PUR外被、Allen Bradley (Rockwell)対応、ケーブル、7.5 x ケーブル外径',
            'sv-SE': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, grundkabel, 7,5 x d',
            'fr-FR': 'Câble de feedback PUR, standard Allen Bradley (Rockwell), cable de base, 7,5 x d',
            'cs-CZ': 'Zpětnovazebný kabel z PUR, standard Allen Bradley (Rockwell), základní kabel, 7,5 x d',
            'da-DK': 'PUR-feedbackkabel, Allen Bradley (Rockwell)-standard, standardkabel, 7,5 x d',
            'ko-KR': 'PUR 피드백 케이블, Allen Bradley(Rockwell) 표준, 기본 케이블, 7.5 x d',
            'hu-HU': 'PUR visszacsatoló kábel, Allen Bradley (Rockwell) szabvány, alapkábel, 7,5 x d',
            'pl-PL': 'Przewód sygnału zwrotnego PUR, norma Allen Bradley (Rockwell), przewód podstawowy, 7,5 x średnica',
            'it-IT': 'Cavo di feedback in PUR, standard Allen Bradley (Rockwell), cavo di base, 7,5 x d',
            'nl-NL': 'readycable® PUR encoderkabel, Allen Bradley (Rockwell) standaard basiskabel, 7,5 x d',
            'en-US': 'PUR feedback cable, Allen Bradley (Rockwell) Standard, base cable, 7.5 x d',
            'pt-PT': 'Cabo de feedback em PUR, norma Allen Bradley (Rockwell), cabo de ligação, 7,5 x d',
            'es-ES': 'PUR cable de realimentación, estándar Allen Bradley (Rockwell) cable básico, 7,5 x d',
            'zh-TW': 'PUR反饋電纜,符合Allen Bradley (Rockwell)標準,基底電纜,彎曲半徑為7.5 x d',
            'zh-CN': 'PUR反馈电缆，符合Allen Bradley (Rockwell)标准，基底电缆，弯曲半径为7.5 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 155 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 50 },
        Kupferzahl: { Unit: 'kg_km', Value: 88 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 69280,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9841753',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '33',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465596706_10637',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G10,0+(2x1,5)C)C',
            'en-US': '(4G10.0+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 21 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 210 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'MAT9851798', US: 'MAT9851798' },
        Bezeichnung: {
            'de-DE': 'readycable® Servoleitung passend zu Allen Bradley 2090-CPBM4DF-08AFxx, Basisleitung PUR 10 x d',
            'sv-SE': 'readycable® servokabel enligt Allen Bradley standard 2090-CPBM4DF-08AFxx, baskabel PUR 10 x d',
            'da-DK': 'readycable® servokabel, i henhold til Allen Bradley standard 2090-CPBM4DF-08AFxx, grundkabel PUR 10 x d',
            'hu-HU': 'readycable® szervókábel, az Allen Bradley szabvány szerint, 2090-CPBM4DF-08AFxx, alapkábel, PUR 10 x d',
            'cs-CZ': 'Servo kabel readycable® v soul. se standardem Allen Bradley 2090-CPBM4DF-08AFxx, základní kabel, PUR 10 x d',
            'nl-NL': 'readycable® servokabel conform Allen Bradley standaard 2090-CPBM4DF-08AFxx, basiskabel, PUR 10 x d',
            'ja-JP': 'レディーケーブル サーボケーブル、Allen Bradley対応、2090-CPBM4DF-08AFxx、ベーシックケーブル PUR外被 10 x d',
            'zh-CN': 'readycable® 伺服电缆，符合 Allen Bradley 标准 2090-CPBM4DF-08AFxx，基础电缆 PUR 10 x d',
            'en-GB': 'readycable® servo cable acc. to Allen Bradley 2090-CPBM4DF-08AFxx, base cable PUR 10 x d',
            'fr-FR': 'Câble servoconducteur readycable® au standard Allen Bradley 2090-CPBM4DF-08AFxx, câble de base, PUR, 10 x d',
            'it-IT': 'readycable® cavo servo in conf. allo standard Allen Bradley 2090-CPBM4DF-08AFxx, cavo base in PUR 10 x d',
            'pt-PT': 'Cabo de servomotor readycable® de acordo com o standard Allen Bradley 2090-CPBM4DF-08AFxx, cabo base em PUR 10 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 788 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 526 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 80176,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9851798',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '34',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465600205_10957',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G10,0+(2x1,5)C)C',
            'en-US': '(4G10.0+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 21 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 210 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'MAT9851798', US: 'MAT9851798' },
        Bezeichnung: {
            'de-DE': 'readycable® Servoleitung passend zu Allen Bradley 2090-CPBM4DF-08AFxx, Basisleitung PUR 10 x d',
            'sv-SE': 'readycable® servokabel enligt Allen Bradley standard 2090-CPBM4DF-08AFxx, baskabel PUR 10 x d',
            'da-DK': 'readycable® servokabel, i henhold til Allen Bradley standard 2090-CPBM4DF-08AFxx, grundkabel PUR 10 x d',
            'hu-HU': 'readycable® szervókábel, az Allen Bradley szabvány szerint, 2090-CPBM4DF-08AFxx, alapkábel, PUR 10 x d',
            'cs-CZ': 'Servo kabel readycable® v soul. se standardem Allen Bradley 2090-CPBM4DF-08AFxx, základní kabel, PUR 10 x d',
            'nl-NL': 'readycable® servokabel conform Allen Bradley standaard 2090-CPBM4DF-08AFxx, basiskabel, PUR 10 x d',
            'ja-JP': 'レディーケーブル サーボケーブル、Allen Bradley対応、2090-CPBM4DF-08AFxx、ベーシックケーブル PUR外被 10 x d',
            'zh-CN': 'readycable® 伺服电缆，符合 Allen Bradley 标准 2090-CPBM4DF-08AFxx，基础电缆 PUR 10 x d',
            'en-GB': 'readycable® servo cable acc. to Allen Bradley 2090-CPBM4DF-08AFxx, base cable PUR 10 x d',
            'fr-FR': 'Câble servoconducteur readycable® au standard Allen Bradley 2090-CPBM4DF-08AFxx, câble de base, PUR, 10 x d',
            'it-IT': 'readycable® cavo servo in conf. allo standard Allen Bradley 2090-CPBM4DF-08AFxx, cavo base in PUR 10 x d',
            'pt-PT': 'Cabo de servomotor readycable® de acordo com o standard Allen Bradley 2090-CPBM4DF-08AFxx, cabo base em PUR 10 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 788 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 526 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 80176,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9851798',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '35',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465600208_10959',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G10,0+(2x1,5)C)C',
            'en-US': '(4G10.0+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 21 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 210 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'MAT9851798', US: 'MAT9851798' },
        Bezeichnung: {
            'de-DE': 'readycable® Servoleitung passend zu Allen Bradley 2090-CPBM4DF-08AFxx, Basisleitung PUR 10 x d',
            'sv-SE': 'readycable® servokabel enligt Allen Bradley standard 2090-CPBM4DF-08AFxx, baskabel PUR 10 x d',
            'da-DK': 'readycable® servokabel, i henhold til Allen Bradley standard 2090-CPBM4DF-08AFxx, grundkabel PUR 10 x d',
            'hu-HU': 'readycable® szervókábel, az Allen Bradley szabvány szerint, 2090-CPBM4DF-08AFxx, alapkábel, PUR 10 x d',
            'cs-CZ': 'Servo kabel readycable® v soul. se standardem Allen Bradley 2090-CPBM4DF-08AFxx, základní kabel, PUR 10 x d',
            'nl-NL': 'readycable® servokabel conform Allen Bradley standaard 2090-CPBM4DF-08AFxx, basiskabel, PUR 10 x d',
            'ja-JP': 'レディーケーブル サーボケーブル、Allen Bradley対応、2090-CPBM4DF-08AFxx、ベーシックケーブル PUR外被 10 x d',
            'zh-CN': 'readycable® 伺服电缆，符合 Allen Bradley 标准 2090-CPBM4DF-08AFxx，基础电缆 PUR 10 x d',
            'en-GB': 'readycable® servo cable acc. to Allen Bradley 2090-CPBM4DF-08AFxx, base cable PUR 10 x d',
            'fr-FR': 'Câble servoconducteur readycable® au standard Allen Bradley 2090-CPBM4DF-08AFxx, câble de base, PUR, 10 x d',
            'it-IT': 'readycable® cavo servo in conf. allo standard Allen Bradley 2090-CPBM4DF-08AFxx, cavo base in PUR 10 x d',
            'pt-PT': 'Cabo de servomotor readycable® de acordo com o standard Allen Bradley 2090-CPBM4DF-08AFxx, cabo base em PUR 10 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 788 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 526 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 80176,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9851798',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '36',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465600209_10961',
        Categories: [LeitungCategory_1.LeitungCategory.DriveTech],
        MainCategory: LeitungCategory_1.LeitungCategory.DriveTech,
        AuhiFreitragendA: { Unit: 'm_s2', Value: 80 },
        VerfahrwegGleitendMax: { Unit: 'm', Value: 10 },
        VerfahrwegFreitragendMax: { Unit: 'm', Value: 10 },
        Leitungsaufbau: {
            'de-DE': '(4G10,0+(2x1,5)C)C',
            'en-US': '(4G10.0+(2x1.5)C)C',
        },
        Aussendurchmesser: { Unit: 'mm', Value: 21 },
        VerfahrwegHaengendMax: { Unit: 'm', Value: 10 },
        FesteLaenge: false,
        AuhiGleitend: false,
        Manufacturer: 'AllenBradley',
        ManufacturerPartNo: '2090-CFBM4DF-CDAFxx',
        AuhiGleitendV: { Unit: 'm_s', Value: 0 },
        RAL_Nummer: '2003',
        AuhiTemperaturMax: { Unit: '°C', Value: 80 },
        BiegeradiusMin: { Unit: 'mm', Value: 210 },
        AuhiFreitragendV: { Unit: 'm_s', Value: 10 },
        GeschwindigkeitHaengendMax: { Unit: 'm_s', Value: 2 },
        ArtNr: { DE: 'MAT9851798', US: 'MAT9851798' },
        Bezeichnung: {
            'de-DE': 'readycable® Servoleitung passend zu Allen Bradley 2090-CPBM4DF-08AFxx, Basisleitung PUR 10 x d',
            'sv-SE': 'readycable® servokabel enligt Allen Bradley standard 2090-CPBM4DF-08AFxx, baskabel PUR 10 x d',
            'da-DK': 'readycable® servokabel, i henhold til Allen Bradley standard 2090-CPBM4DF-08AFxx, grundkabel PUR 10 x d',
            'hu-HU': 'readycable® szervókábel, az Allen Bradley szabvány szerint, 2090-CPBM4DF-08AFxx, alapkábel, PUR 10 x d',
            'cs-CZ': 'Servo kabel readycable® v soul. se standardem Allen Bradley 2090-CPBM4DF-08AFxx, základní kabel, PUR 10 x d',
            'nl-NL': 'readycable® servokabel conform Allen Bradley standaard 2090-CPBM4DF-08AFxx, basiskabel, PUR 10 x d',
            'ja-JP': 'レディーケーブル サーボケーブル、Allen Bradley対応、2090-CPBM4DF-08AFxx、ベーシックケーブル PUR外被 10 x d',
            'zh-CN': 'readycable® 伺服电缆，符合 Allen Bradley 标准 2090-CPBM4DF-08AFxx，基础电缆 PUR 10 x d',
            'en-GB': 'readycable® servo cable acc. to Allen Bradley 2090-CPBM4DF-08AFxx, base cable PUR 10 x d',
            'fr-FR': 'Câble servoconducteur readycable® au standard Allen Bradley 2090-CPBM4DF-08AFxx, câble de base, PUR, 10 x d',
            'it-IT': 'readycable® cavo servo in conf. allo standard Allen Bradley 2090-CPBM4DF-08AFxx, cavo base in PUR 10 x d',
            'pt-PT': 'Cabo de servomotor readycable® de acordo com o standard Allen Bradley 2090-CPBM4DF-08AFxx, cabo base em PUR 10 x d',
        },
        GewichtKgProKm: { Unit: 'kg_km', Value: 788 },
        HaengenderBetriebErlaubt: true,
        AuhiGleitendA: { Unit: 'm_s2', Value: 0 },
        Kupferzahl: { Unit: 'kg_km', Value: 526 },
        AuhiTemperaturMin: { Unit: '°C', Value: -20 },
        Id: 80176,
        BeschleunigungHaengendMax: { Unit: 'm_s2', Value: 50 },
        ArtNrExists: true,
        IsPlaceholder: false,
        ArtNrGenerated: 'MAT9851798',
        UeberstandMitnehmer: { Unit: 'm', Value: 3 },
        UeberstandFestpunkt: { Unit: 'm', Value: 2 },
        Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
        IAIndex: '37',
        Leitungslaenge: { Unit: 'mm', Value: 6507 },
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Readycable],
    },
    {
        EntityId: '1606465612846_11305',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 4 },
        IAIndex: 'F6',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465612848_11307',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 4 },
        IAIndex: 'F7',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465612849_11309',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 4 },
        IAIndex: 'F8',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465612850_11311',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 4 },
        IAIndex: 'F9',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465612850_11313',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 4 },
        IAIndex: 'F10',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465618253_11697',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 3 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F11',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465621741_12089',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F12',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465621742_12091',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 2 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F13',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465624416_12499',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F14',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465624417_12501',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 1 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F15',
        Leitungslaenge: { Unit: 'mm', Value: 3507 },
    },
    {
        EntityId: '1606465626963_12925',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 2 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F16',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
    },
    {
        EntityId: '1606465626963_12927',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '21312' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 2 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F17',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
    },
    {
        EntityId: '1606465630262_13367',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '213123' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 2 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F18',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
    },
    {
        EntityId: '1606465630264_13369',
        Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
        MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
        ArtNrExists: false,
        IsPlaceholder: true,
        RAL_Nummer: '6005',
        Bezeichnung: { 'de-DE': '213123' },
        UeberstandFestpunkt: { Unit: 'm', Value: 1 },
        UeberstandMitnehmer: { Unit: 'm', Value: 2 },
        BiegeradiusMin: { Unit: 'mm', Value: 4 },
        Aussendurchmesser: { Unit: 'mm', Value: 2 },
        GewichtKgProKm: { Unit: 'kg_km', Value: 3 },
        IAIndex: 'F19',
        Leitungslaenge: { Unit: 'mm', Value: 4507 },
    },
];
//# sourceMappingURL=manyDifferentLeitungJsons.js.map